export default function Drawings() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/drawings">
          drawings
        </a>
      </p>
      <table border="0" cellspacing="5" cellpadding="2">
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/draw/coloring2.jpg" target="_blank">
                <img
                  src="/assets/draw/coloring2_sm.jpg"
                  width="117"
                  height="200"
                />
                <br />
                Concept 1 Color
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/draw/drawing_1_coloring.jpg" target="_blank">
                <img
                  src="/assets/draw/drawing_1_coloring_sm.jpg"
                  width="160"
                  height="160"
                />{' '}
                Concept 2 color{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/draw/wildness.jpg" target="_blank">
                <img
                  src="/assets/draw/wildness_sm.jpg"
                  width="117"
                  height="200"
                />
                <br />
                Concept 1 BW{' '}
              </a>
            </div>
          </td>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/draw/m_power.jpg" target="_blank">
                <img
                  src="/assets/draw/m_power_sm.jpg"
                  width="83"
                  height="200"
                />
                <br />M
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td colspan="2">
            <div align="center">
              <a href="/assets/draw/evil_latex.jpg" target="_blank">
                <img
                  src="/assets/draw/evil_latex_sm.jpg"
                  width="200"
                  height="134"
                />
                <br />
                Evil Latex
              </a>
            </div>
          </td>
        </tr>
      </table>
    </>
  );
}
